import { useQueryClient } from "@tanstack/react-query"

import { l2rApiAxiosInstance as axiosInstance } from "@l2r-front/l2r-query"

import { eventsQueryKeys } from "../../queries/events/queryKeys"

import { useIncidentsMutation } from "../useIncidentsMutation"

export function useEventTagsUpdate(
    eventId,
    queryParameters,
    config = {},
) {
    const url = `events/${eventId}/`
    const queryClient = useQueryClient()

    return useIncidentsMutation(
        url,
        axiosInstance.patch,
        {
            ...queryParameters,
        },
        {
            ...config,
            onSuccess: () => {
                queryClient.invalidateQueries({ queryKey: eventsQueryKeys["network"]() })
                queryClient.refetchQueries({ queryKey: eventsQueryKeys["network"]() })
                queryClient.invalidateQueries({ queryKey: eventsQueryKeys["list"]() })
                queryClient.invalidateQueries({ queryKey: eventsQueryKeys["detail"](eventId) })
                queryClient.invalidateQueries({
                    predicate: (query) => {
                        const queryParams = query?.queryKey?.[2]
                        const geoJSONKey = eventsQueryKeys["geoJSON"]()
                        geoJSONKey.pop()
                        const isGeoJSONQuery = geoJSONKey.every(key => query.queryKey.includes(key))
                        const isTagFilteredQuery = Object.keys(queryParams || {}).includes("tags")

                        return isGeoJSONQuery && isTagFilteredQuery
                    },
                })
            },
        },
    )
}